import { theme } from 'styled';

import { IconProps } from './Icon';

export const AddOutlineIcon = ({
  width = 18,
  height = 18,
  color = theme.colors.text.secondary,
  className,
}: IconProps): JSX.Element => (
  <svg
    className={className}
    fill={color}
    height={height}
    id="Layer_1"
    version="1.1"
    viewBox="0 0 93.562 93.562"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M87.952,41.17l-36.386,0.11V5.61c0-3.108-2.502-5.61-5.61-5.61c-3.107,0-5.61,2.502-5.61,5.61l0.11,35.561H5.61
		c-3.108,0-5.61,2.502-5.61,5.61c0,3.107,2.502,5.609,5.61,5.609h34.791v35.562c0,3.106,2.502,5.61,5.61,5.61
		c3.108,0,5.61-2.504,5.61-5.61V52.391h36.331c3.108,0,5.61-2.504,5.61-5.61C93.562,43.672,91.032,41.17,87.952,41.17z"
    />
  </svg>
);
